import React from 'react';
import CallToActionBlock from '~/components/organism/CallToActionBlock';
import TEST_ID from './index.testid';

const text = {
  header: 'Nieuwe kenmerken gevonden',
  description: `Er zijn nieuwe kenmerken in Realworks gevonden. Loop ze via de knop hiernaast door en bepaal per kenmerk of je de relaties met dit kenmerk wilt meenemen. Ken een tag toe wanneer het kenmerk relevant is, of laat de tag leeg. Vergeet niet daarna op te slaan.`,
  button: 'Bekijk nieuwe kenmerken',
};

export type Props = {
  dataTestId?: string;
  missingKenmerkIds: Array<number>;
  onOpenWizard: () => void;
};

const MissingKenmerkenCta: React.FCC<Props> = ({
  dataTestId = TEST_ID.CONTAINER,
  missingKenmerkIds,
  onOpenWizard,
}) => {
  if (missingKenmerkIds.length === 0) {
    return null;
  }

  return (
    <CallToActionBlock
      dataTestId={dataTestId}
      icon={{ name: 'tag', background: { group: 'warning' } }}
      header={text.header}
      description={text.description}
      button={{
        dataTestId: TEST_ID.OPEN_WIZARD_BUTTON,
        label: text.button,
        appearance: 'secondary',
        icon: 'arrowRight',
        onClick: onOpenWizard,
      }}
      padding={['base']}
      margin={[null]}
      align="center"
    />
  );
};

export default MissingKenmerkenCta;
